<template>
  <div class="div">
    <button @click="$router.back()" class="close-button">
      <img src="@/assets/picto_close_qrcode.png"/>
    </button>
    <visite-map class="map" />
  </div>
</template>

<script>

import VisiteMap from '@/components/Geoloc/VisiteMap.vue';
export default {
  components: {
    VisiteMap
  },
}
</script>

<style scoped>
.div {
  position: absolute;
  top: 100px;
  left: 20px;
  right: 20px;
}
.error {
  font-weight: bold;
  color: red;
}
.close-button {
  border: none;
  outline: none;
  background: none;
  position: absolute;
  right: 4px;
  top: 2px;
}
.close-button img {
  width: 35px;
}
</style>
